import isNil from "lodash/fp/isNil";
import isFunction from "lodash/fp/isFunction";

class Controller {
  constructor() {
    "ngInject";
  }

  $onInit() {
    this.isDisabled = isNil(this.isDisabled) ? true : this.isDisabled;
  }

  enableFields() {
    this.isDisabled = false;
  }

  submit() {
    this.isDisabled = true;
    if (isFunction(this.submitCallback)) this.submitCallback();
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/editableFormControls/editableFormControls.controller.js